import React, { JSX, MouseEventHandler } from 'react';
import ProviderResult from './ProviderResult';
import PaginationControls from '../shared/SearchPaginationControls';
import { ProviderFields } from 'components/types/MapTypes';

type ProvidersSearchResultsProps = {
  apiError?: boolean;
  results?: Array<ProviderFields>;
  pageSizeOptions?: Array<number>;
  page: number;
  pageSize: number;
  origin?: Object;
  clearAllFilters: MouseEventHandler<HTMLButtonElement>;
  count: number;
  toggleMobileFilters?: Function;
  updatePageSize?: Function;
  updatePage: (page: number) => void;
  loading?: boolean;
  searchType?: string;
};

const ProvidersSearchResults = (
  props: ProvidersSearchResultsProps
): JSX.Element => {
  const {
    apiError,
    loading,
    clearAllFilters,
    count,
    origin,
    page,
    results,
    pageSize,
    updatePage,
  } = props;

  return (
    <>
      <div className={'results-list-container ' + (loading ? 'loading' : '')}>
        {!loading && results?.length == 0 ? (
          <div className="no-results-message" suppressHydrationWarning>
            {apiError ? (
              <>
                <h2>
                  Something&rsquo;s not quite right. Let&rsquo;s help you find
                  what you&rsquo;re looking for.
                </h2>
                <p>You can try:</p>
                <ul>
                  <li>
                    <button className="osf-link" onClick={clearAllFilters}>
                      Resetting your filters
                    </button>
                  </li>
                  <li>
                    <a href={location.href}>Refreshing the page</a>
                  </li>
                  <li>
                    <a href="https://www.osfhealthcare.org">
                      Returning to the OSF HealthCare homepage
                    </a>
                  </li>
                </ul>
              </>
            ) : (
              <>
                <h2>We can't find any matching providers.</h2>
                <p>Here are a few tips that might help:</p>
                <ul>
                  <li>Check your spelling.</li>
                  <li>
                    Be less specific - try removing a single criteria or
                    choosing a slightly different one.
                  </li>
                  <li>
                    If specifying a location, increase the acceptable distance
                    from your location.
                  </li>
                  <li>
                    Want to start over?{' '}
                    <button className="osf-link" onClick={clearAllFilters}>
                      Reset your filters.
                    </button>
                  </li>
                </ul>
              </>
            )}
          </div>
        ) : (
          <>
            <ul className={`results-list`}>
              {results &&
                results.map((result: ProviderFields, i: number) => {
                  return (
                    <li
                      className={`results-list-item ${i != 0 && (i + 1) % 10 == 0 && 'tenth-item'}`}
                      key={`${result.externalid}-${i}`}
                    >
                      <ProviderResult
                        keyProp={`${result.externalid}-${i}`}
                        origin={origin}
                        provider={result}
                      />
                    </li>
                  );
                })}
            </ul>
            <PaginationControls
              count={count}
              pageSize={pageSize}
              page={page}
              updatePage={updatePage}
            />
          </>
        )}
      </div>
    </>
  );
};
export default ProvidersSearchResults;
